import React from 'react'

import Layout from '../components/Layout'
import NewPasswordForm from '@/features/auth/components/NewPasswordForm'

const NewPasswordPage = () => {
  return (
    <Layout title="Can't Login ? - Login with E Approval account">
      <NewPasswordForm />
    </Layout>
  )
}

export default NewPasswordPage
